import React, { useState } from "react";
import styles from "./../../assets/styles/spec/components/footer.module.scss";
import { ReactComponent as MapPinLogo } from "src/assets/static/images/map-pin.svg";
import { ReactComponent as MailLogo } from "src/assets/static/images/mail.svg";
import { ReactComponent as PhoneLogo } from "src/assets/static/images/phone.svg";
import appStore from "src/assets/static/images/app-store.png";
import googlePlay from "src/assets/static/images/google-play.png";
import { ReactComponent as FaceLogo } from "src/assets/static/images/facebook-logo.svg";
import { ReactComponent as InstaLogo } from "src/assets/static/images/insta-logo.svg";
import { ReactComponent as LinkedinLogo } from "src/assets/static/images/linkedin-logo.svg";
import useFormatById from "src/hooks/utils/useFormatById";
import { useSelector } from "react-redux";
import {
  CLIENT_ABOUTUS,
  CLIENT_BLOGS,
  CLIENT_FINANCIAL_INFO,
  CLIENT_LEGAL_INFO,
  CLIENT_OFFICES,
  CLIENT_VACANCY,
  CLIENT_UNO,
  CLIENT_TRAVEL,
  CLIENT_INSURANCE_AND_MORE,
  CLIENT_CORP_INSURANCE,
  CLIENT_CAR,
  PAY_REDIRECT,
  CLIENT_UNO_ACTIVE,
  CLIENT_UNO_COMFORT,
} from "src/containers/layout";
import CurrentDeviceSize from "src/hooks/utils/currentDeviceSize";
import FooterNavigationItem from "./footerNavigationItem";
import { Link } from "react-router-dom";

const NewFooter = () => {
  const f = useFormatById();
  const lang = useSelector((state) => state.common.lang);
  const deviceSize = CurrentDeviceSize();
  const isMobile = deviceSize === "Mobile";

  const [openedLinkGroups, setOpenedLinkGroups] = useState([]);

  const linkGroupButtonHandler = (id) => {
    setOpenedLinkGroups((prevState) => {
      if (prevState.includes(id)) {
        return prevState.filter((linkGroup) => linkGroup !== id);
      } else {
        return [...prevState, id];
      }
    });
  };

  const forYouLinksData = [
    {
      id: "footer.autoInsurance",
      href: CLIENT_CAR + "/" + lang,
      text: "footer.autoInsurance",
    },
    // {
    //   id: "footer.uno",
    //   href: CLIENT_UNO + "/" + lang,
    //   text: "footer.uno",
    // },
    {
      id: "footer.unoActive",
      href: CLIENT_UNO_ACTIVE + "/" + lang,
      text: "footer.unoActive",
    },
    {
      id: "footer.unoComfort",
      href: CLIENT_UNO_COMFORT + "/" + lang,
      text: "footer.unoComfort",
    },
    {
      id: "footer.travelInsurance",
      href: CLIENT_TRAVEL + "/" + lang,
      text: "footer.travelInsurance",
    },
    {
      id: "footer.insuranceAndMore",
      href: CLIENT_INSURANCE_AND_MORE + "/" + lang,
      text: "footer.insuranceAndMore",
    },
  ];

  const forBusinessLinksData = [
    {
      id: "footer.healthInsurance",
      href: CLIENT_CORP_INSURANCE + "/" + lang,
      text: "footer.healthInsurance",
    },
  ];

  const companyLinksData = [
    {
      id: "footer.aboutUs",
      href: CLIENT_ABOUTUS + "/" + lang,
      text: "footer.aboutUs",
    },
    {
      id: "footer.offices",
      href: CLIENT_OFFICES + "/" + lang,
      text: "footer.offices",
    },
    {
      id: "footer.legalInformation",
      href: CLIENT_LEGAL_INFO + "/" + lang,
      text: "footer.legalInformation",
    },
    {
      id: "footer.financialData",
      href: CLIENT_FINANCIAL_INFO + "/" + lang,
      text: "footer.financialData",
    },
    // {
    //   id: "footer.termsAndConditions",
    //   href: CLIENT_FINANCIAL_INFO + "/" + lang,
    //   text: "footer.termsAndConditions",
    // },
    {
      id: "footer.career",
      href: CLIENT_VACANCY + "/" + lang,
      text: "footer.career",
    },
    {
      id: "footer.news",
      href: CLIENT_BLOGS + "/" + lang,
      text: "footer.news",
    },
  ];

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles["link-groups-wrapper"]}>
          <FooterNavigationItem
            id="forYou"
            header="topbar.forYou"
            openedLinkGroups={openedLinkGroups}
            linkGroupButtonHandler={linkGroupButtonHandler}
            urlList={forYouLinksData}
            isMobile={isMobile}
          />

          <FooterNavigationItem
            id="forBusiness"
            header="topbar.forBusiness"
            openedLinkGroups={openedLinkGroups}
            linkGroupButtonHandler={linkGroupButtonHandler}
            urlList={forBusinessLinksData}
            isMobile={isMobile}
          />

          <FooterNavigationItem
            id="company"
            header="footer.company"
            openedLinkGroups={openedLinkGroups}
            linkGroupButtonHandler={linkGroupButtonHandler}
            urlList={companyLinksData}
            isMobile={isMobile}
          />

          <div
            className={`${styles["link-group"]} ${styles["contact-link-group"]}`}
          >
            <div className={styles["header-and-button-wrapper"]}>
              <h3>{f("footer.contactUs")}</h3>
            </div>
            <ul className={styles["contact-ul"]}>
              <li>
                <MapPinLogo />
                <a target="_blank" href={process.env.REACT_APP_OFFICE_ADRESS}>
                  {f("footer.address")}
                </a>
              </li>
              <li>
                <PhoneLogo />
                <a href="tel:(032) 292 22 22">(032) 292 22 22</a>
              </li>
              <li>
                <MailLogo />
                <a href="mailto:info@imedil.ge">info@imedil.ge</a>
              </li>
            </ul>
          </div>
        </div>

        <Link
          className={styles["pay-redirect-btn"]}
          to={PAY_REDIRECT + "/" + lang}
        >
          {f("payredirect.pay")}
        </Link>

        <div className={styles["footer-social-and-stores-wrapper"]}>
          <div className={styles["stores-links"]}>
            <a
              href="https://apps.apple.com/us/app/imedi-l/id6566193628"
              target="_blank"
              rel="noreferrer"
            >
              <img src={appStore} alt="app-store" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.anonymous.ImediL"
              target="_blank"
              rel="noreferrer"
            >
              <img src={googlePlay} alt="google-play" />
            </a>
          </div>
          <div className={styles["social-links"]}>
            <a
              href="https://www.facebook.com/imediL"
              target="_blank"
              rel="noreferrer"
            >
              <FaceLogo />
            </a>
            <a
              href="https://www.instagram.com/imedi_l/ "
              target="_blank"
              rel="noreferrer"
            >
              <InstaLogo />
            </a>
            <a
              href="https://www.linkedin.com/company/imedil/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedinLogo />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;
